import styled from 'styled-components';
import { error, grey50, white } from 'constants/variables.js';
import toRem from 'utils/toRem';

export interface TextInputBaseProps {
  type?: 'text' | 'email' | 'number' | 'password' | 'tel';
  id: string;
  placeholder?: string;
  value?: string;
  onChange?: () => void;
  onBlur?: () => void;
  disabled?: boolean;
  hasErrors: boolean;
}

const StyledTextInput = styled.input`
  box-sizing: border-box;
  width: 100%;
  border: 1px solid ${grey50};
  padding: ${toRem(12)};
  background-color: ${white};

  &:disabled {
    opacity: 0.3;
    pointer-events: none;
  }

  &.has-error {
    border-color: ${error};
  }
`;

const TextInputBase = ({
  type = 'text',
  id,
  placeholder,
  value,
  onChange,
  onBlur,
  disabled,
  hasErrors,
}: TextInputBaseProps) => (
  <StyledTextInput
    className={`cef-ui-text-input-field${hasErrors ? ' has-error' : ''}`}
    type={type}
    id={id}
    name={id}
    placeholder={placeholder}
    value={value}
    onChange={onChange}
    onBlur={onBlur}
    disabled={disabled}
  />
);

export default TextInputBase;
